import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Stack,
  Divider,
  Badge,
  CircularProgress,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Avatar,
  ListItemAvatar,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  styled,
} from "@mui/material";
import {
  Search,
  Refresh,
  Today,
  DateRange,
  ArrowForward,
  ArrowBack,
  Close,
  AccountBalance,
  CreditCard,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  approvedOrders,
  getMyOrders,
  orderReport,
  orderSales,
  processOrderItem,
} from "../../../api/orders/orders";

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTabBar,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { formatCurrencyN, formatToNaira } from "../../../common/utils_t";
import { useQuery } from "react-query";
import { requestID, baseUrl, config } from "../../../common/utils";
import POSDialog from "../../../components/pos/PosDialog";

// Types
interface OrderItem {
  name: string;
  quantity: number;
  price: number;
}

interface Order {
  id: string;
  createdAt: string;
  order_status: "preparing" | "ready" | "COMPLETED" | "cancelled" | "WAITING";
  items: OrderItem[];
  total: number;
  notes?: string;
}

interface ApiResponse {
  data: Order[];
  total: number;
}

const statusColors = {
  preparing: "warning",
  ready: "success",
  served: "success",
  completed: "success",
  cancelled: "error",
};

const BarSalesPage = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setSelectedstaffList] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState<
    "card" | "transfer" | null
  >(null);

  const [posDialogOpen, setPosDialogOpen] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);

  const [dateRange, setDateRange] = useState<{
    start: Date | null;
    end: Date | null;
  }>({ start: null, end: null });
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

  // Format date to YYYY-MM-DD for API
  const formatDateForApi = (date: Date | null) => {
    if (!date) return "";
    return date.toISOString().split("T")[0];
  };


  const fetchVendorPerformance = async () => {
    const payload = { requestID: requestID, baseUrl, config };
    const response = await axios.post(
      `${baseUrl()}settings/getBarStaff`,
      payload,
      config
    );
    console.log('stffs',{ response });

    return response.data.data;
  };


  const handleClosePosDialog = () => {
    setPosDialogOpen(false);  
  }
  // const handleUpdateOrder = async (order: Order) => {}



  const {
    data,
    isLoading,
    error: isError,
  } = useQuery("fetchStaffs", fetchVendorPerformance);

  // Fetch orders from API
  const fetchOrders = async () => {
    setLoading(true);
    setError(null);

    try {
      const params = {
        page: pagination.page,
        pageSize: pagination.pageSize,
        search: searchTerm,
        order_by: selectedStaff,
        start_date: formatDateForApi(dateRange.start),
        end_date: formatDateForApi(dateRange.end),
      };
console.log("Params for orders:", params);
      const response = await orderSales(params);

      console.log("Orders response11:", response.data);
      setOrders(response.data);

      setPagination((prev) => ({
        ...prev,
        total: response.data?.length,
      }));
    } catch (err) {
      setError("Failed to fetch orders. Please try again.");
      console.error("Error fetching orders:", err);
    } finally {
      setLoading(false);
    }
  };

  // Initial fetch and when filters change
  useEffect(() => {
    fetchOrders();
  }, [dateRange]);

  // Time formatting
  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  // Date formatting
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  // Date range display text
  const getDateRangeText = () => {
    if (!dateRange.start && !dateRange.end) return "All dates";
    if (dateRange.start && !dateRange.end)
      return `From ${formatDate(dateRange.start.toISOString())}`;
    if (!dateRange.start && dateRange.end)
      return `Until ${formatDate(dateRange.end.toISOString())}`;
    return `${formatDate(dateRange.start?.toISOString() || "")} - ${formatDate(
      dateRange.end?.toISOString() || ""
    )}`;
  };

  // Handle pagination
  const handlePageChange = (newPage: number) => {
    setPagination((prev) => ({
      ...prev,
      page: Math.max(
        1,
        Math.min(newPage, Math.ceil(pagination.total / pagination.pageSize))
      ),
    }));
  };

  // Open order details modal
  const handleOpenOrderDetails = (order: Order) => {
    setSelectedOrder(order);
  };

  const handleCloseOrderDetails = () => {
    setSelectedOrder(null);
  };

  const handleProcessOrder = async (status: "COMPLETED" | "cancelled") => {
    try {
      const payload = {
        order_id: selectedOrder.order_id,
        status: status,
      };
      await approvedOrders(payload);
      setSelectedOrder(null);
      fetchOrders();
    } catch (error) {
      console.error("Error processing order:", error);
      // Handle error (show toast, etc.)
    }
  };

  const editOrderHandler = (order: Order) => {
    // cartCtx.clearCart();
    // console.log({ order });

    // order.items.forEach((item) => {
    //   cartCtx.addItem({
    //     id: item.product_id,
    //     product_id: item.product_id,
    //     product_name: item.product_name,
    //     price: item.price,
    //     quantity: parseInt(item.quantity),
    //   });
    // });

    // console.log("cartctx", cartCtx.items);

    // setOpenAddModal(true);
  };



  const total = orders?.reduce(
    (sum, order) => sum + parseFloat(order.payable_amount),
    0
  );


  //waiting orders
  const cardTotal_w = orders
  .filter(order =>  order?.order_status === 'WAITING')
  .reduce((sum, order) => sum + parseFloat(order?.payable_amount), 0);

 
  
const sumOrders = (orders, filterFn) =>
  orders?.filter(filterFn).reduce((sum, order) => sum + parseFloat(order?.payable_amount || 0), 0);
 
const cardTotal_c = sumOrders(orders, order =>
  order?.order_status === 'COMPLETED' && order?.payment_status === '0'
);

const cardTotal_p = sumOrders(orders, order =>
  order?.mode_of_payment === 'card' && order?.payment_status === '1'
);

const transferTotal_p = sumOrders(orders, order =>
  order?.mode_of_payment === 'transfer' && order?.payment_status === '1'
);

const walletQrTotal_p = sumOrders(orders, order =>
  order?.mode_of_payment === 'wallet_qrcode' && order?.payment_status === '1'
);
  // cardTotal  transferTotal  walletQrTotal
  

  const handleEditOrder = async (order) => {
    setSelectedOrder(order)
    setPosDialogOpen(true);
  }

  const handleUpdateOrder = (updatedOrder) => {
    setOrders(orders.map(order => 
      order.id === updatedOrder.id ? updatedOrder : order
    ));
    setPosDialogOpen(false);
    setViewDialogOpen(false);
  };
const ColorIndicator = styled('div')(({ color }) => ({
  width: 12,
  height: 12,
  backgroundColor: color,
  borderRadius: 2,
  marginRight: 8,
}));

const PaymentRow = ({ color, label, amount }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <ColorIndicator color={color} />
    <Typography variant="body1">
      {label}: <Typography component="span" fontWeight="bold">{formatToNaira(amount)}</Typography>
    </Typography>
  </Box>
);
const totalWaiting = cardTotal_w ;//+ transferTotal_w + walletQrTotal_w;
const totalCompleted = cardTotal_c ;//+ transferTotal_c + walletQrTotal_c;
const totalPaid = cardTotal_p + transferTotal_p + walletQrTotal_p;
//export default PaymentSummary;
  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Bar Orders</IonTitle>
          </IonToolbar>
        </IonHeader>
      </IonHeader>

      <IonContent>
        <Box sx={{ p: 3 }}>
          {/* Filters Section */}
          <Paper sx={{ p: 2, mb: 3 }}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ mb: 2 }}
            >
              <TextField
                placeholder="Search orders or items..."
                variant="outlined"
                size="small"
                fullWidth
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && fetchOrders()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />

              <DatePicker
                label="Start Date"
                value={dateRange.start}
                onChange={(newValue) =>
                  setDateRange((prev) => ({ ...prev, start: newValue }))
                }
                renderInput={(params) => <TextField {...params} size="small" />}
                components={{
                  OpenPickerIcon: DateRange,
                }}
              />

              <DatePicker
                label="End Date"
                value={dateRange.end}
                onChange={(newValue) =>
                  setDateRange((prev) => ({ ...prev, end: newValue }))
                }
                renderInput={(params) => <TextField {...params} size="small" />}
                components={{
                  OpenPickerIcon: DateRange,
                }}
                minDate={dateRange.start}
              />

              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel>Staff</InputLabel>
                <Select
                  label="Staff"
                  value={selectedStaff}
                  onChange={(e) => setSelectedStaff(e.target.value)}
                >
                  <MenuItem value="">All Staff</MenuItem>
                  {data?.map((staff,I) => (
                    <MenuItem key={staff.id} value={staff.user_id}>
                      {staff.firstName  + " " + staff.lastName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Button
                variant="outlined"
                onClick={() => setDateRange({ start: null, end: null })}
              >
                Clear Dates
              </Button>

              <IconButton onClick={fetchOrders} disabled={loading}>
                <Refresh />
              </IconButton>
            </Stack>

            <Typography variant="body2" color="text.secondary">
              {getDateRangeText()} • Showing {orders?.length} of{" "}
              {pagination?.total} orders
            </Typography>
          </Paper>

          {/* Loading and Error States */}
          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          )}

          {error && (
            <Paper sx={{ p: 2, mb: 3, bgcolor: "error.light" }}>
              <Typography color="error">{error}</Typography>
              <Button onClick={fetchOrders} sx={{ mt: 1 }}>
                Retry
              </Button>
            </Paper>
          )}

          {/* Orders Table */}
          {!loading && !error && (
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>S/N</TableCell>
                      <TableCell>Date/Time</TableCell>
                      <TableCell>Order By</TableCell>
                      <TableCell>Items Count</TableCell>
                      <TableCell align="right">Total</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders?.length > 0 ? (
                      orders?.map((order, i) => (
                        <TableRow key={i} hover>
                          <TableCell>
                            <Typography fontWeight="bold">{i + 1}</Typography>
                          </TableCell>
                          <TableCell>
                            {formatDate(order.order_date)} •{" "}
                            {formatTime(order.order_date)}
                          </TableCell>
                          <TableCell>{order.order_by} </TableCell>
                          <TableCell>{order.items.length} items</TableCell>
                          <TableCell align="right">
                            {formatToNaira(order.payable_amount)}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={order?.order_status}
                              color={
                                statusColors[
                                  order?.order_status.toLowerCase()
                                ] || "default"
                              }
                            />
                          </TableCell>
                          <TableCell align="right">
                            <Button
                              size="small"
                              variant="outlined"
                              endIcon={<ArrowForward />}
                              onClick={() => handleOpenOrderDetails(order)}
                            >
                              Details
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                          <Typography variant="body1" color="text.secondary">
                            No orders found matching your criteria
                          </Typography>
                          <Button
                            variant="text"
                            startIcon={<Refresh />}
                            onClick={fetchOrders}
                            sx={{ mt: 1 }}
                          >
                            Refresh
                          </Button>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
              >
                <Button
                  startIcon={<ArrowBack />}
                  onClick={() => handlePageChange(pagination.page - 1)}
                  disabled={pagination.page === 1 || loading}
                >
                  Previous
                </Button>

                <Typography variant="body1">
                  Page {pagination.page} of{" "}
                  {Math.ceil(pagination.total / pagination.pageSize)}
                </Typography>

                <Button
                  endIcon={<ArrowForward />}
                  onClick={() => handlePageChange(pagination.page + 1)}
                  disabled={
                    pagination.page * pagination.pageSize >= pagination.total ||
                    loading
                  }
                >
                  Next
                </Button>
              </Box>
            </>
          )}

<Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      

      {/* COMPLETED Orders */}
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
          COMPLETED Orders (Unpaid)
        </Typography>
        <Box sx={{ display: 'flex', gap: 3 }}>
          <PaymentRow color="#4e79a7" label="Total Unpaid" amount={cardTotal_c} />
         
        </Box>
      </Paper>

      {/* PAID Orders */}
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
          PAID Orders
        </Typography>
        <Box sx={{ display: 'flex', gap: 3 }}>
          <PaymentRow color="#4e79a7" label="Card" amount={cardTotal_p} />
          <PaymentRow color="#f28e2b" label="Transfer" amount={transferTotal_p} />
          <PaymentRow color="#e15759" label="Wallet" amount={walletQrTotal_p} />
        </Box>
      </Paper>
    </Box>
{/* <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
  <Typography variant="body1" sx={{ mr: 1 }}>Total:</Typography>
  <Typography variant="body1" fontWeight="bold">{formatToNaira(totalPaid)}</Typography>
</Box> */}
          <Box
            sx={{
              mt: 3,
              textAlign: "center",
              display: "flex",
              gap: 2,
              alignItems: "center",
            }}
          >
            <Typography variant="h4" gutterBottom>
              Total Paid Orders :
            </Typography>
            <Typography variant="h4" color="primary">
              {/* {formatToNaira(total)} */}
              {formatToNaira(totalPaid)}
            </Typography>
          </Box>
          {/* Order Details Modal */}
          <Dialog
            open={Boolean(selectedOrder)}
            onClose={handleCloseOrderDetails}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="h6">
                  Order #{selectedOrder?.order_code}
                </Typography>
                <IconButton onClick={handleCloseOrderDetails}>
                  <Close />
                </IconButton>
              </Box>
              <Typography variant="subtitle2" color="text.secondary">
                {selectedOrder &&
                  `${formatDate(selectedOrder.order_date)} • ${formatTime(
                    selectedOrder.order_date
                  )}`}
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Order By: {selectedOrder?.order_by}
              </Typography>
            </DialogTitle>

            <DialogContent dividers>
              {selectedOrder && (
                <>
                  <Box mb={2}>
                    <Chip
                      label={selectedOrder?.order_status}
                      color={
                        statusColors[selectedOrder?.order_status] || "default"
                      }
                      size="medium"
                    />
                  </Box>

                  <List dense>
                    {selectedOrder.items?.map((item, index) => (
                      <ListItem key={index}>
                        <ListItemAvatar>
                          <Avatar sx={{ bgcolor: "primary.main" }}>
                            {item?.productName.charAt(0)}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={item?.productName}
                          secondary={
                            <>
                              <Box component="span" display="block">
                                Qty: {item.quantity}
                              </Box>
                              <Box component="span" display="block">
                                Price: {formatToNaira(item.price)}
                              </Box>
                              {item.item_status && (
                                <Chip
                                  label={item.item_status}
                                  size="small"
                                  color={
                                    item.item_status === "approved"
                                      ? "success"
                                      : item.item_status === "rejected"
                                      ? "error"
                                      : "warning"
                                  }
                                  sx={{ mt: 0.5 }}
                                />
                              )}
                            </>
                          }
                        />
                        <ListItemSecondaryAction>
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-end"
                          >
                            <Typography fontWeight="bold">
                              {formatToNaira(item.price * item.quantity)}
                            </Typography>
                          </Box>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>

                  <Divider sx={{ my: 2 }} />

                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="subtitle1">Subtotal:</Typography>
                    <Typography variant="subtitle1">
                      {formatToNaira(selectedOrder.payable_amount)}
                    </Typography>
                  </Box>

                  {selectedOrder.notes && (
                    <>
                      <Divider sx={{ my: 2 }} />
                      <Typography variant="subtitle2">Notes:</Typography>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        {selectedOrder.notes}
                      </Typography>
                    </>
                  )}

                  

              {/*  <Divider sx={{ my: 2 }} />   {selectedOrder.order_status == "WAITING" && (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography variant="subtitle1">Order Status:</Typography>
                      <Box display="flex" gap={1}>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => handleProcessOrder("COMPLETED")}
                        >
                          Complete Order
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => handleProcessOrder("cancelled")}
                        >
                          Cancel Order
                        </Button>
                         <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => handleEditOrder(selectedOrder)}
                        >
                          Edit  Order
                        </Button> 
                      </Box>
                    </Box>
                  )}

                  {selectedOrder.order_status === "COMPLETED" && (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box display="flex" gap={1}>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => setShowPaymentDialog(true)}
                        >
                          Proceed to payment
                        </Button>
                      </Box>
                    </Box>
                  )} */}
                </>
              )}
            </DialogContent>

            <DialogActions>
              <Button
                onClick={handleCloseOrderDetails}
                variant="contained"
                color="primary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>




          {/* {selectedOrder && (
            <POSDialog open={posDialogOpen} onClose={handleClosePosDialog} order={selectedOrder} onSave={handleUpdateOrder}/>
          )} */}
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default BarSalesPage;
